import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
import store from '../state/store';
import { getAffId } from '../utils/getAffId';
import { postLogin } from '../state/query/login';
import { AUTH_TYPES, ERROR_TYPES, LOGIN_ERROR_TYPE } from '../utils/authFlow/constants';
import ENVIRONMENT_VARIABLES from '../utils/environmentVariables';
import { getText, TEXT_KEY } from '../utils/localization';
import { setAvailableServiceStatus } from '../state/actions/availableServices';
import { clearGoogleToken, setGoogleToken } from '../state/actions/auth';

/**
 * Social login helper methods
 * Used in Start, TrackingURL(landing page) and LinkAccount
 */
export default {
  /**
   *
   * GOOGLE
   *
   */
  getGoogleId: function () {
    var _getGoogleId = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(token) {
      var parts, encodedPayload, decodedPayload, payload;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            // split token into header, payload, and signature
            parts = token.split('.');
            encodedPayload = parts[1]; // decode the payload from base64 and parse it as JSON
            if (!encodedPayload) {
              _context.next = 6;
              break;
            }
            decodedPayload = Buffer.from(encodedPayload, 'base64').toString('utf-8');
            payload = JSON.parse(decodedPayload);
            return _context.abrupt("return", payload.sub);
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    function getGoogleId(_x) {
      return _getGoogleId.apply(this, arguments);
    }
    return getGoogleId;
  }(),
  /**
   * @summary loads the google sign-in script
   */
  loadGsi: function () {
    var _loadGsi = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var _document$querySelect, script;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (!window.isGsiLoaded) {
              script = document.createElement('script');
              script.src = 'https://accounts.google.com/gsi/client';
              script.onload = this.initializeGsi;
              script.async = true;
              script.id = 'google-client-script';
              (_document$querySelect = document.querySelector('body')) === null || _document$querySelect === void 0 || _document$querySelect.appendChild(script);
              window.isGsiLoaded = true;
            }
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2, this);
    }));
    function loadGsi() {
      return _loadGsi.apply(this, arguments);
    }
    return loadGsi;
  }(),
  /**
   * @summary initializes gsi sdk and sets googleAuth
   * as an available service
   */
  initializeGsi: function initializeGsi() {
    if (!window.google || !window.isGsiLoaded) return;
    window.google.accounts.id.initialize({
      client_id: ENVIRONMENT_VARIABLES.GOOGLE_CLIENT_ID,
      callback: function callback(response) {
        return store.dispatch(setGoogleToken(response.credential));
      }
    });
    store.dispatch(setAvailableServiceStatus({
      googleAuth: true
    }));
  },
  googleLoginHandler: function () {
    var _googleLoginHandler = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(_ref) {
      var setCanceledState, setErrorState, setSuccessState, googleToken, aff_id, googleId, inviteLinkId, response, _error$data, socialErrorType;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            setCanceledState = _ref.setCanceledState, setErrorState = _ref.setErrorState, setSuccessState = _ref.setSuccessState;
            _context3.prev = 1;
            googleToken = store.getState().token.google_token;
            _context3.next = 5;
            return getAffId();
          case 5:
            aff_id = _context3.sent;
            googleId = this.getGoogleId(googleToken);
            inviteLinkId = store.getState().playerInfo.inviteLink;
            _context3.next = 10;
            return store.dispatch(postLogin.initiate(_objectSpread(_objectSpread({
              id_token: googleToken,
              google_id: googleId,
              login_type: AUTH_TYPES.GOOGLE
            }, aff_id && {
              aff_id: aff_id
            }), inviteLinkId && {
              inviteLinkId: inviteLinkId
            }))).unwrap();
          case 10:
            response = _context3.sent;
            if (response.success) {
              _context3.next = 13;
              break;
            }
            throw response;
          case 13:
            setSuccessState();
            store.dispatch(clearGoogleToken());
            _context3.next = 22;
            break;
          case 17:
            _context3.prev = 17;
            _context3.t0 = _context3["catch"](1);
            this._handleLoginError(_context3.t0, setCanceledState, setErrorState, LOGIN_ERROR_TYPE.GOOGLE);
            socialErrorType = 'google';
            setCanceledState({
              statusMessage: ((_error$data = _context3.t0.data) === null || _error$data === void 0 ? void 0 : _error$data.message) || _context3.t0.message,
              socialErrorType: socialErrorType
            });
          case 22:
          case "end":
            return _context3.stop();
        }
      }, _callee3, this, [[1, 17]]);
    }));
    function googleLoginHandler(_x2) {
      return _googleLoginHandler.apply(this, arguments);
    }
    return googleLoginHandler;
  }(),
  /**
   *
   * FACEBOOK
   *
   */
  facebookLoginHandler: function () {
    var _facebookLoginHandler = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(_ref2) {
      var _this = this;
      var FB, permAccepted, setErrorState, setSuccessState, setCanceledState, fbLoginAuthType;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            FB = _ref2.FB, permAccepted = _ref2.emailPermissionAccepted, setErrorState = _ref2.setErrorState, setSuccessState = _ref2.setSuccessState, setCanceledState = _ref2.setCanceledState;
            fbLoginAuthType = permAccepted === false ? {
              auth_type: 'rerequest'
            } : {};
            FB.login(
            /*#__PURE__*/
            /**
             * @param {Object} response
             * @param {String} response.status
             * @param {Object} response.authResponse
             * @param {String} response.authResponse.accessToken
             * @param {String} response.authResponse.userID
             */
            function () {
              var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(response) {
                var emailPermissionAccepted, aff_id, inviteLinkId, request, statusMessage;
                return _regeneratorRuntime().wrap(function _callee4$(_context4) {
                  while (1) switch (_context4.prev = _context4.next) {
                    case 0:
                      emailPermissionAccepted = !!response.authResponse && !!response.authResponse.grantedScopes && response.authResponse.grantedScopes.includes('email');
                      if (!(response.status === 'connected' && emailPermissionAccepted)) {
                        _context4.next = 20;
                        break;
                      }
                      setSuccessState();
                      _context4.prev = 3;
                      _context4.next = 6;
                      return getAffId();
                    case 6:
                      aff_id = _context4.sent;
                      inviteLinkId = store.getState().playerInfo.inviteLink;
                      _context4.next = 10;
                      return store.dispatch(postLogin.initiate(_objectSpread(_objectSpread({
                        token: response.authResponse.accessToken,
                        userID: response.authResponse.userID,
                        login_type: AUTH_TYPES.FACEBOOK
                      }, aff_id && {
                        aff_id: aff_id
                      }), inviteLinkId && {
                        inviteLinkId: inviteLinkId
                      }))).unwrap();
                    case 10:
                      request = _context4.sent;
                      if (request.success) {
                        _context4.next = 13;
                        break;
                      }
                      throw request;
                    case 13:
                      _context4.next = 18;
                      break;
                    case 15:
                      _context4.prev = 15;
                      _context4.t0 = _context4["catch"](3);
                      _this._handleLoginError(_context4.t0, setCanceledState, setErrorState, LOGIN_ERROR_TYPE.FACEBOOK);
                    case 18:
                      _context4.next = 23;
                      break;
                    case 20:
                      statusMessage = getText(TEXT_KEY.FACEBOOK_LOGIN_ERROR);
                      if (response.status === 'connected' && !emailPermissionAccepted) {
                        statusMessage = getText(TEXT_KEY.FACEBOOK_ACCEPT_PERMISSION);
                      }
                      setCanceledState({
                        statusMessage: statusMessage,
                        emailPermissionAccepted: emailPermissionAccepted,
                        socialErrorType: 'facebook'
                      });
                    case 23:
                    case "end":
                      return _context4.stop();
                  }
                }, _callee4, null, [[3, 15]]);
              }));
              return function (_x4) {
                return _ref3.apply(this, arguments);
              };
            }(), _objectSpread({
              scope: 'email',
              return_scopes: true
            }, fbLoginAuthType));
          case 3:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    function facebookLoginHandler(_x3) {
      return _facebookLoginHandler.apply(this, arguments);
    }
    return facebookLoginHandler;
  }(),
  facebookLoginHandlerForLinkAccount: function facebookLoginHandlerForLinkAccount(FB) {
    return new Promise(function (resolve) {
      FB.login( /*#__PURE__*/function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(response) {
          var emailPermissionAccepted, statusMessage;
          return _regeneratorRuntime().wrap(function _callee6$(_context6) {
            while (1) switch (_context6.prev = _context6.next) {
              case 0:
                emailPermissionAccepted = !!response.authResponse && !!response.authResponse.grantedScopes && response.authResponse.grantedScopes.includes('email');
                if (response.status === 'connected' && emailPermissionAccepted) {
                  resolve({
                    success: true,
                    facebookUser: response.authResponse
                  });
                } else {
                  statusMessage = getText(TEXT_KEY.FACEBOOK_LOGIN_ERROR);
                  if (response.status === 'connected' && !emailPermissionAccepted) {
                    statusMessage = getText(TEXT_KEY.FACEBOOK_ACCEPT_PERMISSION);
                  }
                  resolve({
                    success: false,
                    error: statusMessage
                  });
                }
              case 2:
              case "end":
                return _context6.stop();
            }
          }, _callee6);
        }));
        return function (_x5) {
          return _ref4.apply(this, arguments);
        };
      }(), {
        scope: 'email',
        return_scopes: true,
        auth_type: 'rerequest'
      });
    });
  },
  /**
   *
   * COMMON
   *
   */
  _handleLoginError: function _handleLoginError(error, setCanceledState, setErrorState, loginErrorType) {
    var _error$data2, _error$data3;
    var genericErrorMessage = getText(TEXT_KEY.PLAYER_EMAIL_UPDATE_ERROR);
    var errorCode = ((_error$data2 = error.data) === null || _error$data2 === void 0 ? void 0 : _error$data2.error_code) || error.error_code;
    var message = ((_error$data3 = error.data) === null || _error$data3 === void 0 ? void 0 : _error$data3.message) || error.message || genericErrorMessage;
    setCanceledState({
      statusMessage: message,
      socialErrorType: errorCode === ERROR_TYPES.GEO_BLOCK ? LOGIN_ERROR_TYPE.COUNTRY_BLOCKED : loginErrorType
    });
  }
};